import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ReportBase } from '../report.base';
import { ActivatedRoute } from '@angular/router';
import { ReportsService } from '../../../../services';
import {
  take, ComparisonReportSession, AppState, Store, AppFields, ComparisonReport, AutoUnsubscribe, Subscription, Months, filter
} from '../../../../store';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AmChartsService, AmChart } from '@amcharts/amcharts3-angular';
import * as _ from 'lodash';

@Component({
  selector: 'app-comparison-report',
  templateUrl: './comparison-report.component.html',
  styleUrls: ['./comparison-report.component.css']
})
@AutoUnsubscribe
export class ComparisonReportComponent extends ReportBase implements OnInit, AfterViewInit {

  @Input() programName;
  report: ComparisonReport = new ComparisonReport();
  sessions: ComparisonReportSession[] = [];
  sub: Subscription;
  selectedProgramId: number;
  currentProgramId: number;
  selectedYear: number;
  chart: AmChart;

  constructor(
    public route: ActivatedRoute,
    public service: ReportsService,
    public store: Store<AppState>,
    private spinnerService: Ng4LoadingSpinnerService,
    private chartService: AmChartsService
  ) {
    super(service, store);
  }

  ngOnInit() {
    this.sub = this.store.select(AppFields.App, AppFields.Club).subscribe(
      club => {
        if (club) {
          this.getSessions(club.clubID);
        }
      }
    );
  }

  ngAfterViewInit() {
    this.chart = this.chartService.makeChart('comparison-report-graph', {
      type: 'serial',
      theme: 'light',
      marginRight: 40,
      marginLeft: 40,
      autoMarginOffset: 20,
      synchronizeGrid: true,
      responsive: {
        enabled: true
      },
      graphs: [
        {
          fillAlphas: 0.8,
          lineAlpha: 0.2,
          type: 'column',
          valueField: `currentProgram`,
          balloonText: '<strong>[[title]]</strong>: $[[value]]',
          title: 'Current Program',
          fillColors: '#5c80d1'
        },
        {
          fillAlphas: 0.8,
          lineAlpha: 0.2,
          type: 'column',
          valueField: `selectedProgram`,
          balloonText: '<strong>[[title]]</strong>: $[[value]]',
          title: 'Selected Program',
          fillColors: '#373737'
        }
      ],
      chartCursor: {
        cursorPosition: 'mouse'
      },
      categoryField: 'date',
      categoryAxis: {
        autoRotateAngle: 15,
        autoRotateCount: 8,
        autoWrap: true
      }
    });
  }

  getSessions(clubID) {
    this.spinnerService.show();

    this.program.pipe(filter(p => !!p), take(1)).subscribe(program => {
      this.service.getComparisonReportSessions(clubID, program.clubProgramTypeID).subscribe(sessions => {
        this.sessions = sessions;
        this.currentProgramId = +program.clubprogramID;
        this.service.getComparisonReportCurrentProgramData(this.currentProgramId).subscribe(
          currentProgramData => {
            this.report.currentProgramData = currentProgramData;
            this.spinnerService.hide();
          }
        );

        if (sessions.length) {
          this.selectedProgramId = sessions[0].clubprogramID;
          this.getComparisonReport();
        }
      });
    });

  }

  getComparisonReport() {
    this.spinnerService.show();
    this.service.getComparisonReport(this.currentProgramId, this.selectedProgramId).subscribe(
      report => {
        this.report = report;
        this.selectedYear = this.report.paymentYearList ? this.report.paymentYearList[0] : null;
        this.spinnerService.hide();
        this.updateChart();
      }
    );
  }

  updateChart() {
    const dataByYear = _.groupBy(this.report.currentProgramData.monthlyPaymentList, (payment) => payment.paymentMonth.getFullYear());
    const comparingDataByYear = _.groupBy(this.report.selectedProgramData.monthlyPaymentList,
      (payment) => payment.paymentMonth.getFullYear());

    this.chart.graphs[0].title = this.report.currentProgramData.clubProgramData.programName;
    this.chart.graphs[1].title = this.report.selectedProgramData.clubProgramData.programName;

    const data = dataByYear[this.selectedYear] || [];
    const comparingData = comparingDataByYear[this.selectedYear] || [];
    const years = Object.keys(dataByYear).sort();
    if (years.length) {
      this.chart.dataProvider = Months.map((month, idx) => {
        const cpIndex = data.findIndex(d => d.paymentMonth.getMonth() === idx);
        const spIndex = comparingData.findIndex(d => d.paymentMonth.getMonth() === idx);
        return {
          date: month,
          currentProgram: cpIndex > -1 ? data[cpIndex].paymentAmount.toFixed(2) : 0,
          selectedProgram: spIndex > -1 ? comparingData[spIndex].paymentAmount.toFixed(2) : 0
        };
      });
      this.chart.validateData();
    }
  }

  get currentProgramData() {
    return this.report.currentProgramData.clubProgramData;
  }

  get comparingProgramData() {
    return this.report.selectedProgramData.clubProgramData;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/comparison-report/comparison-report.component.ts